export const combinationToCard = (combination: string) => {
  const cards = []
  let i = 0
  while (i < combination.length) {
    const [rank, suit] = combination.slice(i, i + 2).split('')
    cards.push({ rank, suit })
    i += 2
  }
  return cards
}

export const percentToColor = (percent: number) => {
  if (percent <= 20) {
    return '#aa1b1b'
  } else if (percent <= 40) {
    return '#b95f1e'
  } else if (percent <= 60) {
    return '#a39f27'
  } else if (percent <= 80) {
    return '#4d9231'
  } else if (percent > 80) {
    return '#29b336'
  } else {
    return ''
  }
}
